import { useState, useEffect } from 'react';

export default function FloatingButtons() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="floating-buttons"
      className="fixed bottom-20 right-4 sm:right-6 z-40 flex flex-col gap-3"
      style={{ animation: 'slideInRight 0.5s ease' }}
    >
      {/* WhatsApp */}
      <a
        href="https://wa.me/5596991374064"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="group relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center
          shadow-lg hover:scale-110 transition-transform duration-300"
        title="Fale conosco pelo WhatsApp"
      >
        {/* Pulse ring */}
        <span className="absolute w-full h-full rounded-full bg-[#25D366]"
          style={{ animation: 'pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite' }} />
        <i className="fab fa-whatsapp text-2xl relative z-10"></i>
        {/* Tooltip */}
        <span className="absolute right-16 bg-gray-900 text-white text-xs py-2 px-3 rounded-lg whitespace-nowrap
          opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg">
          Fale conosco pelo WhatsApp
          <span className="absolute top-1/2 -right-1 -translate-y-1/2 border-4 border-transparent border-l-gray-900" />
        </span>
      </a>

      {/* Email */}
      <a
        href="mailto:sindpesca.pa.ap@gmail.com?subject=Contato%20pelo%20Site%20SINDPESCA&body=Ol%C3%A1%2C%20gostaria%20de%20entrar%20em%20contato%20com%20o%20SINDPESCA."
        data-testid="floating-email"
        className="group relative w-14 h-14 rounded-full bg-[#E8621A] text-white flex items-center justify-center
          shadow-lg hover:scale-110 transition-transform duration-300"
        title="Enviar e-mail"
        style={{ animation: 'bounce-subtle 2s ease-in-out infinite' }}
      >
        <i className="fas fa-envelope text-xl"></i>
        {/* Tooltip */}
        <span className="absolute right-16 bg-gray-900 text-white text-xs py-2 px-3 rounded-lg whitespace-nowrap
          opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg">
          Enviar e-mail
          <span className="absolute top-1/2 -right-1 -translate-y-1/2 border-4 border-transparent border-l-gray-900" />
        </span>
      </a>
    </div>
  );
}
